export const baseUrl =
  process.env.NODE_ENV === 'development'
    ? 'https://api.contactmate.fi/index.php'
    : 'https://api.contactmate.fi/index.php';
